import React from "react"
import Bowser from "bowser"

import { ImgFluid } from "../../../components"
import {
  extractImageNameFromUrl,
  checkMobileDeviceExceptSamsungInternet,
  checkMobileIos,
} from "../../../helper"

import s from "./SkewedBackgroundHero.module.scss"

class SkewedBackgroundHero extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobileDeviceExceptSamsungInternet: true,
      isMobileIos: false,
    }
  }
  componentDidMount() {
    if (typeof window !== "undefined") {
      this.setState({
        isMobileDeviceExceptSamsungInternet:
          checkMobileDeviceExceptSamsungInternet(window, Bowser),
        isMobileIos: checkMobileIos(window, Bowser),
      })
    }
  }

  render() {
    const {
      title_one_text,
      title_one_color,
      title_two_text,
      title_two_color,
      bottle_image,
    } = this.props
    const { isMobileDeviceExceptSamsungInternet, isMobileIos } = this.state

    let titleOneClasses = [s.Title]
    if (title_one_color) titleOneClasses.push(title_one_color)
    else titleOneClasses.push("WhiteColor")
    let titleTwoClasses = [s.TitleTwo]
    if (title_two_color) titleTwoClasses.push(title_two_color)
    else titleTwoClasses.push("WhiteColor")
    let sectionClasses = [s.SkewedBackgroundHero]
    if (isMobileDeviceExceptSamsungInternet)
      sectionClasses.push(s.SkewedBackgroundHeroMobileDevice)
    if (isMobileIos) sectionClasses.push(s.SkewedBackgroundHeroIphoneSafari)

    return (
      <section
        className={sectionClasses.join(" ")}
        style={{ zIndex: this.props.sectionZindex }}
      >
        <div className={s.BackgroundBanner}></div>
        <div className={s.Content}>
          <div className={s.TitleWrapper}>
            <h1
              className={titleOneClasses.join(" ")}
              dangerouslySetInnerHTML={{ __html: title_one_text }}
            ></h1>
          </div>
          <div className={s.TitleAndImageWrapper}>
            <div className={s.TitleAndImageGrouper}>
              <h2
                className={titleTwoClasses.join(" ")}
                dangerouslySetInnerHTML={{ __html: title_two_text }}
              ></h2>
              <div className={s.ImageWrapper}>
                <ImgFluid
                  fileName={extractImageNameFromUrl(bottle_image)}
                  alt={title_one_text}
                />
              </div>
              <div className={s.Shadow}>
                <div className={s.ShadowWrapper}>
                  <ImgFluid fileName={"bottle_shadow.png"} loading="eager" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default SkewedBackgroundHero
